/**
 * Handles all radios and checkboxes to be togglable with enter key
 * @module charCounter
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'charCounter';
export const DEFAULTS = {

};

const getMaxChar = ($el) => {
  const maxChar = $el.attr('maxlength');
  return maxChar;
};

const countCurrentChar = ($el) => {
  const charCount = $el.val().length;
  return charCount;
};

const displayMaxChar = ($el, getMaxChar) => {
  const maxCharContianer = $el.attr("data-count-max");
  $(maxCharContianer).text(getMaxChar($el));
};

const displayCharCount = ($el, countCurrentChar) => {
  const charCountContainer = $el.attr("data-count-total");
  $(charCountContainer).text(countCurrentChar($el));
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el) => {
  $el.on('input', () => {
    displayCharCount($el, countCurrentChar);
  });
};

/**
 * Initializes charCounter.
 * @param {HTMLElement} el - button /element that opens charCounter
 * @see DEFAULTS
 */
export default function charCounter(el) {
  const $el = $(el);
  displayMaxChar($el, getMaxChar);
  setEventListeners($el);
}
registerJQueryPlugin(PLUGIN_NAME, charCounter);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/char-counter.js